import { GridsterItem } from 'angular-gridster2';
import { BasicButtonColors, BasicButtonModes, BasicButtonSizes } from '@app/shared/enums/buttons';

export enum WidgetViewStates {
  LOADING = 'LOADING',
  WIDGETS = 'WIDGETS',
  NO_WIDGETS = 'NO_WIDGETS'
}

export enum WidgetTypes {
  DATAGRID = 'DATAGRID',
  NOTIFICATIONS = 'NOTIFICATIONS',
}

export const ButtonConfigs = {
  BasicButtonColors,
  BasicButtonModes,
  BasicButtonSizes,
};

export interface IWidget extends GridsterItem {
  id?: string;
  categoryId?: string;
  title: string;
  type: WidgetTypes;
  config?: string;
  path?: string;
  dataCy?: string;
}

export interface IDraggableImages extends GridsterItem {
  imageUrl?: string;
}

export interface IWidgetCategory {
  id: string;
  widgets: IWidget[];
}
